var $648096d15e55c0ec$exports = {};
$648096d15e55c0ec$exports = {
    "collapse": `\u{6298}\u{308A}\u{305F}\u{305F}\u{3080}`,
    "expand": `\u{5C55}\u{958B}`
};


export {$648096d15e55c0ec$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
